import * as betprofessor from './CloseAccount.styles.betprofessor';
import * as betroyale from './CloseAccount.styles.betroyale';
import * as fiestabet from './CloseAccount.styles.fiestabet';
import * as goldenrush from './CloseAccount.styles.goldenrush';
import * as juicybet from './CloseAccount.styles.juicybet';
import * as puntgenie from './CloseAccount.styles.puntgenie';
import * as puntcity from './CloseAccount.styles.puntcity';
import * as questbet from './CloseAccount.styles.questbet';
import * as sterlingparker from './CloseAccount.styles.sterlingparker';
import * as volcanobet from './CloseAccount.styles.volcanobet';
import * as junglebet from './CloseAccount.styles.junglebet';
import * as oldgill from './CloseAccount.styles.oldgill';
import * as sugarcastle from './CloseAccount.styles.sugarcastle';
import * as buffalobet from './CloseAccount.styles.buffalobet';
import * as vikingbet from './CloseAccount.styles.vikingbet';
import * as titanbet from './CloseAccount.styles.titanbet';
import * as slambet from './CloseAccount.styles.slambet';
import * as gigabet from './CloseAccount.styles.gigabet';
import * as betstride from './CloseAccount.styles.betstride';
import * as goldenbet888 from './CloseAccount.styles.goldenbet888';
import * as hyperbet from './CloseAccount.styles.hyperbet';
import * as bet777 from './CloseAccount.styles.bet777';
import * as chromabet from './CloseAccount.styles.chromabet';
import * as bet575 from './CloseAccount.styles.bet575';
import * as betblast from './CloseAccount.styles.betblast';
import * as pyramidbet from './CloseAccount.styles.pyramidbet';
import * as magnumbet from './CloseAccount.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntgenie,
  puntcity,
  questbet,
  sterlingparker,
  volcanobet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  vikingbet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
